import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import * as React from "react";
import { cn } from "../../utils";
import { Loading } from "./Loading";
const buttonVariants = cva("inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground shadow-sm hover:bg-primary/90",
            destructive: "bg-destructive text-destructive-foreground shadow-xs hover:bg-destructive/90",
            outline: "border border-input bg-background shadow-xs hover:bg-accent hover:text-accent-foreground",
            secondary: "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80",
            accent: "bg-accent text-accent-foreground shadow-sm hover:bg-accent/90",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline",
        },
        size: {
            default: "h-9 px-4 py-2",
            sm: "h-8 rounded-md px-3 text-xs",
            lg: "h-10 rounded-md px-8",
            icon: "h-9 w-9",
        },
    },
    defaultVariants: {
        variant: "default",
        size: "default",
    },
});
const Button = React.forwardRef(({ className, variant, size, loading, children, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (_jsxs(Comp
    // without this, buttons inside a form default to type="submit"
    , { 
        // without this, buttons inside a form default to type="submit"
        type: asChild ? undefined : "button", className: cn(buttonVariants({ variant, size, className })), ref: ref, ...props, children: [!!loading && _jsx(Loading, { className: "mr-2" }), children] }));
});
Button.displayName = "Button";
export { Button, buttonVariants };
